import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { partition } from 'rxjs/operator/partition';
import { map } from 'rxjs/operators';

@Injectable()
export class NautoService {
  httpOptions ={
    headers: new HttpHeaders({'Content-Type':'application/json'})
  };
  constructor(private _http: HttpClient) { }

  getNautoDevice(){
    var device = this._http.get('/nautodevices');
    //device.state = this.getNautoState();
    //device.
    return this._http.get('/nautodevices');
  }

  getNautoState(){
    return this._http.get('/nautostates');
  }

  getNautoVehicle(){
    return this._http.get('/nautovehicles');
  }

  getAllNautoTrips(){
    return this._http.get('/nautotrips/TodaysVehicle');
  }

  getNautoTrips(){
    return this._http.get('/nautotrips/LastSeenVehicle');
    // .pipe(
    //   map((data: any[]) => data.map((item: any) => {
    //       if(item.isactive){
    //         return item; 
    //       }
    //   }))
    // );
  }

  searchNautoTrips(vehiclenumber) {
    let config = {
      headers: new HttpHeaders({'Content-Type':'application/json'})
    };

    if(vehiclenumber) {
      config["params"] = {
        filter: JSON.stringify({"where":{"name":vehiclenumber},"order": "updatedAt DESC","limit":20})
      };
    }
    // {"where":{"name":"D087"},"order": "updatedAt DESC","limit":20}
    // return this._http.get('/nautotrips/search?q='+vehiclenumber);
    return this._http.get('/nautotrips', config);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/nauto/nauto.service.ts